export var LAYERS = [0, 1];
export var DEFAULT_LAYER = 0;
/* Build a `{ 0: ..., 1: ... }` record with the same initial value per layer. */
export var perLayer = function (make) {
    return LAYERS.reduce(function (acc, layer) {
        acc[layer] = make();
        return acc;
    }, {});
};
